
import Vue from 'vue'
import {
  Component,
  Emit,
  Prop,
  Watch,
} from 'nuxt-property-decorator'
import { globalLabelAsString } from '../../shared/general/services/StoreService'
import { TPreFilter } from '../../shared/general/types/TPreFilter'
import BaseButton from '../base/BaseButton.vue'
import BaseCheckbox from '../base/form/BaseCheckbox.vue'
import BaseDropdown from '../base/form/BaseDropdown.vue'
import BaseGridLayout from '../layouts/BaseGridLayout.vue'
import BaseRadio from '../base/form/BaseRadio.vue'
import LocationTypeFilters from './LocationTypeFilters.vue'
import TopBar from './TopBar.vue'
import ICheckbox from '../../shared/general/interfaces/ICheckbox'
import IDropdownOption from '../../shared/general/interfaces/IDropdownOption'

@Component({
  name: 'LocationPreFilters',
  components: {
    LocationTypeFilters,
    TopBar,
    BaseButton,
    BaseCheckbox,
    BaseDropdown,
    BaseGridLayout,
    BaseRadio,
  },
})
export default class LocationPreFilters extends Vue {
  @Prop({ default: () => [] }) filters! : IDropdownOption[]

  @Prop({ required: false }) commercialVehiclesFilter ?: string

  @Prop({ default: () => ({ filterValue: '', commercialVehicles: false }) }) preSelection! : TPreFilter

  private isMobileOverlayOpened : boolean = false

  private currentSelection : TPreFilter = { filterValue: '', commercialVehicles: false }

  private get suitableForCommercialVehiclesLabel () : string {
    return globalLabelAsString('suitable_for_commercial_vehicles_label')
  }

  private get filterLabel () : string {
    return globalLabelAsString('filters_label')
  }

  private get applyLabel () : string {
    return globalLabelAsString('apply_label')
  }

  private radioChanged (filterValue : string) {
    const commercialVehicles = this.currentSelection.commercialVehicles && filterValue === this.commercialVehiclesFilter
    this.currentSelection = { filterValue, commercialVehicles }
    this.fireChange()
  }

  private checkboxClicked (state : ICheckbox) {
    this.currentSelection = { filterValue: this.commercialVehiclesFilter || '', commercialVehicles: state.value }
    this.fireChange()
  }

  private updateSelection (newSelection : TPreFilter) {
    this.currentSelection = { ...newSelection }
  }

  private applyMobile () {
    this.isMobileOverlayOpened = false
    this.fireChange()
  }

  @Watch('preSelection', { immediate: true })
  private handlePreSelectionChanged () {
    if (this.currentSelection.filterValue !== this.preSelection.filterValue
      || this.currentSelection.commercialVehicles !== this.preSelection.commercialVehicles
    ) {
      this.currentSelection = this.preSelection
    }
  }

  @Emit('change')
  private fireChange () : TPreFilter {
    return { ...this.currentSelection }
  }
}
